// Layout de Suporte (/support): existe só como passagem para as três telas
// (Ajuda, lista de chamados, chamado), que chegam aqui via <Outlet />. A
// navegação entre elas é só pelo grupo "Suporte" da barra lateral/drawer
// (ver sidebar e mobile-nav) — a barra de abas que vivia aqui foi removida.
import { Outlet } from "@tanstack/react-router";

export function SupportLayout() {
  return <Outlet />;
}
